import type { PersistedBusiness } from "schemas";
import { useLiteSiteStore } from "../store";

export function setBusiness(business: PersistedBusiness | undefined) {
  useLiteSiteStore.setState(() => ({ business }));
}
